export const formatDateTime = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return new Intl.DateTimeFormat(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(date);
};

export const formatDate = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return new Intl.DateTimeFormat(undefined, { dateStyle: "medium" }).format(date);
};

export const formatNumber = (value) =>
  new Intl.NumberFormat(undefined, { maximumFractionDigits: 2 }).format(
    Number(value || 0),
  );

export const getRiskReviewErrorMessage = (error) =>
  error?.response?.data?.message ||
  error?.response?.data?.error ||
  error?.message ||
  "Unable to complete the request.";

export const getValidationErrors = (error) =>
  error?.response?.data?.errors || error?.errors || [];

export const valuesArrayToMap = (values) => {
  if (!Array.isArray(values)) return values || {};
  return values.reduce((map, item) => {
    map[item.fieldCode] = item.value;
    return map;
  }, {});
};

export const getRequestId = (request) =>
  request?.requestNo ||
  (request?._id ? `${String(request._id).slice(0, 8)}...` : "New Risk Review");

export const getRequesterName = (request) =>
  request?.requester?.name ||
  request?.requester?.fullName ||
  request?.requester?.email ||
  "—";

export const getHighestRisk = (risks = []) => {
  const order = { CRITICAL: 4, HIGH: 3, MEDIUM: 2, LOW: 1 };
  return [...(risks || [])]
    .filter((risk) => risk.triggered)
    .sort((a, b) => (order[b.severity] || 0) - (order[a.severity] || 0))[0];
};

export const getTemplateDeclarationFieldCodes = (template) =>
  (template?.sections || [])
    .flatMap((section) => section.fields || [])
    .filter((field) => {
      const text = `${field.code || ""} ${field.label || ""}`.toLowerCase();
      return field.inputType === "CHECKBOX" && /declaration|confirm/.test(text);
    })
    .map((field) => field.code)
    .filter(Boolean);

export const hasTemplateDeclarationField = (template) =>
  getTemplateDeclarationFieldCodes(template).length > 0;
